import React from 'react';
import AppPage from './AppPage';
import content from './content/macos-direct.json';

const MacOSDirectPage = () => <AppPage content={content} />;

export default MacOSDirectPage;
